
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Bar, mixins } from 'vue-chartjs';
import { generateBarLine, BarWithLineConfig, BarWithLineSetting } from './bar-with-line';
import {
  _isEmpty,
} from '@samclick-lodash';

enum BarChartType {
    BAR_WITH_LINE = 'BAR_WITH_LINE',
}

@Component({
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
})
class BarChart extends Vue<Bar> {
    @Watch('$props.data', { immediate: true })
  dataWatcher(newVal: string, oldVal: string) {
    if (!_isEmpty(newVal)) {
      this.renderBarChart();
    } else if (_isEmpty(newVal) && this._data && this._data._chart) {
      this._data._chart.destroy();
    }
  }

    @Watch('$i18n.i18nLoadedAt')
    watchConfig(newVal: string, oldVal: string) {
      this.renderBarChart();
    }

    renderBarChart() {
      const self = this;
      let chartDetail = { labels: [], datasets: [] };
      if (this.$props.type === BarChartType.BAR_WITH_LINE) {
        chartDetail = generateBarLine(this.$props.config, this.$props.data, this.$props);
      }

      this.$nextTick(() => {
        self.renderChart(chartDetail.chartData, chartDetail.chartOptions);
      });
    }

    mounted() {
      this.renderBarChart();
    }
}

export { BarChartType, BarWithLineConfig, BarWithLineSetting };
export default BarChart;
